import React from 'react';
import PropTypes from 'prop-types';

export function SeqencePlaceholder({ visible, src, opacity }) {
  return <div className="sequence-placeholder lazyBackground" data-visible={visible} style={{ backgroundImage: `url(${src})`, opacity }} />;
}

SeqencePlaceholder.propTypes = {
  opacity: PropTypes.number,
  visible: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired
};
